import { useEffect } from "react";
import { doc, getDoc, updateDoc, arrayUnion } from "firebase/firestore";
import { db } from "../../../firebase";


export const updateGenres = async (data) => {
    try {
        const updateData = data.genreList;
        let userGenres = data.genres;
        const docRef = doc(db, 'users', data.UID);

        if (userGenres.length === 0) {
            Object.keys(updateData).forEach(key => {
                updateData[key] = 0;
            });
        } else {
            Object.keys(updateData).forEach(key => {
                if (userGenres.includes(key)) {
                    updateData[key] = 10;
                
                } else if (updateData[key] === 10) {
                    updateData[key] = 0;
                }
            });
        }
        console.log('bark',updateData, userGenres)
        await updateDoc(docRef, { genreList: updateData });

        console.log("Document updated successfully!");
    } catch (error) {
        console.error("Error updating document: ", error);
    }
};

  
export default function Update({ user, data }) {
    useEffect(() => {
        const updateGenres = async () => {
            if (user && data) {
                const ref = doc(db, "users", user.uid);
                try {
                    const snap = await getDoc(ref);
                    const userGenres = snap.data().genreList;
                    const dataGenres = data.genres;

                    
                    const flatDataGenres = dataGenres.map(genre => genre.split(' ')).flat();

                    
                    const updatedGenres = { ...userGenres };

                    for (let key in updatedGenres) {
                        if (!flatDataGenres.some(genre => key.toLowerCase().includes(genre.toLowerCase()))) {
                           
                            updatedGenres[key] = Math.max(updatedGenres[key] - 1, 0);
                        } else if (!updatedGenres[key] || updatedGenres[key] < 10) {
                           
                            updatedGenres[key] = Math.min((updatedGenres[key] || 0) + 2, 10);
                        }
                    }
                    console.log(updatedGenres)
                    
                    await updateDoc(ref, { genreList: updatedGenres });
                } catch (error) {
                    console.error("Error updating document:", error);
                }
            }
        };

        updateGenres();
    }, [user, data]);

    return null; 
}